import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Alert, Typography } from "@mui/material";
import { Button } from "@mui/material";
import { Box } from "@mui/system";
import { TextField } from "@mui/material";
import RecipeSelector from "./RecipeSelector";
import Switch from "@mui/material/Switch";
import ConfigData from "../config/config.json";
import { GlobalMessageContext } from "../app/App";

const webserver = ConfigData.WEBSERVER;

const label = { inputProps: { "aria-label": "Switch demo" } };

export default function NewScenario(props) {
  const [saveDisabled, setSaveDisabled] = React.useState(true);
  const [errors, setErrors] = React.useState({
    scenarioExistsError: "",
  });
  const { setGlobalMessage } = React.useContext(GlobalMessageContext);

  const [title, setTitle] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [selectedRecipes, setSelectedRecipes] = React.useState([]);
  const [active, setActive] = React.useState(false);

  const clearForm = () => {
    setTitle("");
    setDescription("");
    setSelectedRecipes([]);
  };

  const toggleSwitch = () => {
    if (selectedRecipes.length === 0 && !active) {
    } else {
      setActive((prev) => !prev);
    }
  };

  useEffect(() => {
    if (!(title === "" || description === "")) {
      setSaveDisabled(false);
    } else {
      setSaveDisabled(true);
    }
  }, [title, description, selectedRecipes]);

  const handleSubmitNewUser = (e) => {
    const formData = { title, description, active, recipes: selectedRecipes };

    e.preventDefault();
    setSaveDisabled(true);

    fetch(
      webserver.protocol +
        "://" +
        webserver.host +
        ":" +
        webserver.port +
        "/scenario/add",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(formData),
      }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Unable to access endpoint: scenario/add");
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data < 0) {
          setErrors({
            scenarioExistsError: "Der Szenariotitel ist bereits vergeben.",
          });
        } else {
          clearForm();
          props.setRows((prev) =>
            prev.concat([
              {
                id: data,
                title: title,
                description: description,
                active: active,
                recipes: selectedRecipes,
              },
            ])
          );
          setGlobalMessage({
            globalMessage: "Szenario angelegt",
            severity: "success",
          });
        }
      })
      .catch((error) => {
        setGlobalMessage({
          globalMessage: "Vorgang fehlgeschlagen",
          severity: "error",
        });
      })
      .finally(() => setSaveDisabled(false));
  };

  return (
    <Dialog open={props.open} onClose={() => props.setOpen(false)}>
      <Box component="form" onSubmit={(e) => handleSubmitNewUser(e)}>
        <DialogTitle>Neues Szenario anlegen</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            id="newScenarioTitle"
            label="Titel"
            type="text"
            fullWidth
            variant="standard"
            required
            value={title}
            onInput={(e) => {
              setTitle(e.target.value);
            }}
          />
          <TextField
            sx={{ mb: 3 }}
            multiline
            margin="dense"
            id="newScenarioDescription"
            label="Beschreibung"
            type="text"
            fullWidth
            variant="standard"
            required
            value={description}
            onInput={(e) => {
              setDescription(e.target.value);
            }}
          />

          {
            //TODO state management
          }
          <RecipeSelector
            width="100%"
            selectedRecipes={selectedRecipes}
            setSelectedRecipes={setSelectedRecipes}
            active={active}
            setActive={setActive}
          />

          <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
            <Switch
              {...label}
              checked={active}
              onChange={() => toggleSwitch()}
            />
            <Typography>{active ? "Aktiv" : "Inaktiv"}</Typography>
          </Box>

          {errors.scenarioExistsError && (
            <Alert sx={{ mt: 3 }} variant="outlined" severity="error">
              <ul style={{ margin: 0 }}>
                {errors.scenarioExistsError && (
                  <li key="scenarioExistsError">
                    {errors.scenarioExistsError}
                  </li>
                )}
              </ul>
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => props.setOpen(false)}>Schließen</Button>
          <Button onClick={() => clearForm()}>Formular leeren</Button>
          <Button type="submit" disabled={saveDisabled}>
            Hinzufügen
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
